import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { CompanyNote } from "@/types";

/**
 * This hook is used to remove a company note in the company notes query
 * without refetching the entire query.
 */
export const useRemoveCompanyNote = () => {
  const currentCompanyId = useCurrentCompanyId();
  const queryClient = useQueryClient();

  return ({ companyNoteId }: { companyNoteId: number }) => {
    queryClient.setQueryData(
      ["company-notes", currentCompanyId],
      (cachedData: CompanyNote[]) => {
        return cachedData.filter(
          (cachedCompanyNote: CompanyNote) =>
            cachedCompanyNote.id !== companyNoteId,
        );
      },
    );
  };
};
